
import {
    UserPermission,
    Unit,
    UnitType,
    Owner,
    Vehicle,
    WaterReading,
    TariffService,
    TariffParking,
    VehicleTier,
    TariffWater,
    Adjustment,
    ParkingTariffTier,
    NewsItem,
    FeedbackItem,
} from './types';

export const MOCK_USER_PERMISSIONS: UserPermission[] = [];

const areaMap: { [key: string]: number } = {
    '02': 88, '04': 57.6, '06': 57.6, '08': 82.6, '10': 59.1,
    '12': 57.6, '14': 57.6, '16': 63.2, '18': 63.2, '20': 57.6,
    '22': 57.6, '24': 59.1, '26': 82.6, '28': 57.6, '30': 57.6, '32': 88,
};

const generateMockUnitsAndOwners = () => {
    const units: Unit[] = [];
    const owners: Owner[] = [];
    return { units, owners };
};

// --- START: KIOS Area Patch ---
const KIOS_AREAS: { [key: string]: number } = {
  'Kios 1': 67.5, 'Kios 2': 61.32, 'Kios 3': 166.1, 'Kios 4': 0, 'Kios 5': 65.15,
  'Kios 6': 65.15, 'Kios 7': 64.5, 'Kios 8': 78.4, 'Kios 9': 99.4, 'Kios 10': 64.5,
  'Kios 11': 65.8, 'Kios 12': 87.7, 'Kios 13': 78.4, 'Kios 14': 61.32, 'Kios 15': 67.5,
};

export function patchKiosAreas(units: Unit[]): void {
  for (const u of units) {
    if (u.UnitType === UnitType.KIOS) {
      const kiosNum = parseInt(u.UnitID.substring(1), 10);
      const key = `Kios ${kiosNum}`;
      if (KIOS_AREAS[key] != null) {
        u.Area_m2 = KIOS_AREAS[key];
      }
    }
  }
}

const { units: generatedUnits, owners: generatedOwners } = generateMockUnitsAndOwners();
patchKiosAreas(generatedUnits);

export const MOCK_UNITS: Unit[] = generatedUnits;
export const MOCK_OWNERS: Owner[] = generatedOwners;

const generateResidentUsers = (units: Unit[]): UserPermission[] => {
    return units.map(unit => ({
        Email: `${unit.UnitID.toLowerCase()}@qhome.vn`,
        Username: unit.UnitID,
        Role: 'Resident',
        status: 'Active',
        password: '123456',
        mustChangePassword: true,
        residentId: unit.UnitID,
    }));
};

const residentUsers = generateResidentUsers(generatedUnits);
MOCK_USER_PERMISSIONS.push(...residentUsers);

export const MOCK_VEHICLES: Vehicle[] = [];

const generateStableMockWaterReadings = (allUnits: Unit[]): WaterReading[] => {
    return [];
};

export const MOCK_WATER_READINGS: WaterReading[] = generateStableMockWaterReadings(MOCK_UNITS);

export const MOCK_TARIFFS_SERVICE: TariffService[] = [];

export const MOCK_TARIFFS_PARKING: TariffParking[] = [
    { Tier: ParkingTariffTier.CAR, Price_per_unit: 1200000, VAT_percent: 10, ValidFrom: '2024-01-01', ValidTo: null },
    { Tier: ParkingTariffTier.CAR_A, Price_per_unit: 1500000, VAT_percent: 10, ValidFrom: '2024-01-01', ValidTo: null },
    { Tier: ParkingTariffTier.MOTO12, Price_per_unit: 100000, VAT_percent: 10, ValidFrom: '2024-01-01', ValidTo: null },
    { Tier: ParkingTariffTier.MOTO34, Price_per_unit: 150000, VAT_percent: 10, ValidFrom: '2024-01-01', ValidTo: null },
    { Tier: ParkingTariffTier.BICYCLE, Price_per_unit: 30000, VAT_percent: 10, ValidFrom: '2024-01-01', ValidTo: null },
];

export const DEFAULT_PARKING_TARIFFS = MOCK_TARIFFS_PARKING;

export const MOCK_TARIFFS_WATER: TariffWater[] = [];

export const MOCK_ADJUSTMENTS: Adjustment[] = [];

export const MOCK_NEWS_ITEMS: NewsItem[] = [];

export const MOCK_FEEDBACK_ITEMS: FeedbackItem[] = [];
